/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserReactionsEmojiSummaryResponseV3EmojisInnerFromJSON, InternalUserReactionsEmojiSummaryResponseV3EmojisInnerToJSON, } from './InternalUserReactionsEmojiSummaryResponseV3EmojisInner';
import { InternalUserReactionsEmojiResponseV3EmojiFromJSON, InternalUserReactionsEmojiResponseV3EmojiToJSON, } from './InternalUserReactionsEmojiResponseV3Emoji';
/**
 * Check if a given object implements the InternalUserReactionsEmojiSummaryResponseV3 interface.
 */
export function instanceOfInternalUserReactionsEmojiSummaryResponseV3(value) {
    if (!('emojiDefinition' in value) || value['emojiDefinition'] === undefined)
        return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined)
        return false;
    if (!('emojis' in value) || value['emojis'] === undefined)
        return false;
    return true;
}
export function InternalUserReactionsEmojiSummaryResponseV3FromJSON(json) {
    return InternalUserReactionsEmojiSummaryResponseV3FromJSONTyped(json, false);
}
export function InternalUserReactionsEmojiSummaryResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'emojiDefinition': InternalUserReactionsEmojiResponseV3EmojiFromJSON(json['emoji_definition']),
        'totalCount': json['total_count'],
        'emojis': (json['emojis'].map(InternalUserReactionsEmojiSummaryResponseV3EmojisInnerFromJSON)),
    };
}
export function InternalUserReactionsEmojiSummaryResponseV3ToJSON(json) {
    return InternalUserReactionsEmojiSummaryResponseV3ToJSONTyped(json, false);
}
export function InternalUserReactionsEmojiSummaryResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'emoji_definition': InternalUserReactionsEmojiResponseV3EmojiToJSON(value['emojiDefinition']),
        'emojis': (value['emojis'].map(InternalUserReactionsEmojiSummaryResponseV3EmojisInnerToJSON)),
    };
}
